var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import Button from "../Button";
import { PLAY_WHITE_SVG, PLAY_GRAY_SVG, SHUFFLE_GRAY_SVG, SHUFFLE_WHITE_SVG } from '../../assets';
import { messages } from '../../messages';
var PlayShuffleSelector = /** @class */ (function (_super) {
    __extends(PlayShuffleSelector, _super);
    function PlayShuffleSelector(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    PlayShuffleSelector.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: this.props.className },
            React.createElement(Button, { selected: this.props.selected == 'play', color: 'gray', onClick: function () {
                    if (_this.props.selected != 'play') {
                        _this.props.onChanged('play');
                    }
                    else {
                        _this.props.onChanged(undefined);
                    }
                }, style: this.props.buttonStyle || ButtonStyle, icon: PLAY_GRAY_SVG, iconSelected: PLAY_WHITE_SVG, iconWidth: 18, text: messages.PlayAll }),
            React.createElement(Button, { selected: this.props.selected == 'shuffle', color: 'gray', onClick: function () {
                    if (_this.props.selected != 'shuffle') {
                        _this.props.onChanged('shuffle');
                    }
                    else {
                        _this.props.onChanged(undefined);
                    }
                }, style: __assign(__assign({}, this.props.buttonStyle || ButtonStyle), { marginLeft: '12px' }), icon: SHUFFLE_GRAY_SVG, iconSelected: SHUFFLE_WHITE_SVG, iconWidth: 18, text: messages.ShuffleAll })));
    };
    return PlayShuffleSelector;
}(React.PureComponent));
export default PlayShuffleSelector;
var ButtonStyle = {
    height: '48px',
    width: '112px'
};
//# sourceMappingURL=PlayShuffleSelector.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/components/selector/PlayShuffleSelector.js
// module id = 1286
// module chunks = 0